import { Programa } from './Programa';

export class Categoria {
    constructor(id, codigo, descripcion, rowsPorCategoria) {
        this.id = id;
        this.codigo = codigo;
        this.descripcion = descripcion;
        this.programas = [];

        for (var i = 0; i < rowsPorCategoria.length; i++) {
            this.programas.push(new Programa(rowsPorCategoria[i].Id, rowsPorCategoria[i].Codigo, rowsPorCategoria[i].Launcher, rowsPorCategoria[i].Descripcion, rowsPorCategoria[i].CodigoPantalla));
        }
    }
}



// WEBPACK FOOTER //
// ./Portico/App/Common/Categoria.js